import analytics from '../../analytics';
import { MODAL_LOAD_EVENT } from './lib';
const changeSizeChartUnits = () => {
    const radioSwitch = document.querySelector('.js-size-chart-units-switch');
    const tableCells = document.querySelectorAll('td[data-value-imp], th[data-value-imp]');
    if (!radioSwitch || tableCells.length === 0)
        return;
    const metricInput = radioSwitch.querySelector('#size-chart-switch-metric');
    const imperialInput = radioSwitch.querySelector('#size-chart-switch-imperial');
    if (!metricInput || !imperialInput)
        return;
    metricInput.addEventListener('change', () => {
        if (metricInput.checked) {
            tableCells.forEach((tableCell) => {
                tableCell.querySelector('span').innerHTML = tableCell.dataset.value;
            });
        }
    });
    imperialInput.addEventListener('change', () => {
        if (imperialInput.checked) {
            tableCells.forEach((tableCell) => {
                tableCell.querySelector('span').innerHTML = tableCell.dataset.valueImp;
            });
        }
    });
};
export default () => {
    const sizesDialog = document.querySelector('#dialog-sizes');
    const sizesPage = document.querySelector('#page-sizes');
    if (sizesDialog || sizesPage) {
        changeSizeChartUnits();
        if (sizesDialog) {
            sizesDialog.addEventListener(MODAL_LOAD_EVENT, () => {
                analytics.sizeGuide(JSON.parse(document.querySelector('[data-tracking]').dataset.tracking));
            });
        }
    }
};
